import { render, staticRenderFns } from "./SubscriptionEdit.vue?vue&type=template&id=610b6bee&scoped=true&"
import script from "./SubscriptionEdit.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionEdit.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionEdit.vue?vue&type=style&index=0&id=610b6bee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610b6bee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VDialog,VForm,VSelect,VSwitch,VTextField,VTooltip})
